<template>
  <div class="a">
    <!-- 头部 -->
    <titled :num="3"></titled>
    <span class="apphome">
      <div class="box">
        <div class="top">
          <div class="right">
            <span class="title_right">健康预测</span>
            <vchart
              style="height: calc(100vh - 190px);width:100%;"
              ref="vchart2"
            ></vchart>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>
<script>
import titled from "@/components/module/titled/titled.vue";
import vchart from "@/components/module/chart/vchart.vue";
export default {
  components: {
    titled,
    vchart,
  },
  data() {
    return {
      dayOption: {
        grid: {
          // 距离 上右下左 的距离
          left: "5%",
          right: "5%",
          bottom: "8%",
          top: "16%",
          // 大小是否包含文本【类似于boxsizing】
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        xAxis: {
          type: "category",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
        },
        yAxis: {
          name: "百分比（%）",
          nameTextStyle: {
            fontSize: 15,
            padding: [0, 0, 0, 30],
            color: "#999",
            rich: {
              a: {
                // 没有设置 `lineHeight`，则 `lineHeight` 为 56
              },
            },
          },
          axisLine: {
            show: true,
          },
          type: "value",
        },
        series: [
          {
            name: "信息",
            data: [99, 97, 96, 94, 90, 87, 85, 81, 78, 75, 70],
            type: "line",
          },
        ],
      },
      options: [
        {
          value: "1",
          label: "今年",
        },
        {
          value: "2",
          label: "今天",
        },
        {
          value: "3",
          label: "昨天",
        },
      ],
      value: "",
    };
  },
  computed: {
    setDeviceItem() {
      return this.$store.cacheStore.state.setDevice;
    },
  },
  watch: {
    setDeviceItem: function(val) {
      console.log(val);
      var d = [];
      for (let i = 0; i < 12; i++) {
        d.push(Math.round(Math.random() * 80));
      }
      this.dayOption.series[0].data = d;
      this.$refs.vchart2.setData(this.dayOption, true);
    },
  },
  mounted() {
    // var d = [];
    // var num = 2023;
    // for (let i = 0; i < 11; i++) {
    //   d.push(num + i);
    // }
    // this.dayOption.xAxis.data = d;
    this.$refs.vchart2.setData(this.dayOption, true);
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.apphome .box .name {
  height: 30px;
  font-family: "Microsoft YaHei";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;
  color: #999;
  margin-bottom: 5px;
}

.title_right {
  font-family: "Microsoft YaHei";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #4ca5ff;
  display: block;
  margin-left: 25px;
  margin-top: 20px;
}

.box .right {
  flex: 1;
}

.box .left {
  width: 450px;
}

.left_name {
  display: block;
  margin-left: 25px;
  margin-top: 20px;
}

.apphome .left .name {
  height: 30px;
  font-family: "Microsoft YaHei";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;
  color: #999;
  margin-bottom: 5px;
}

.apphome .box {
  height: calc(100vh - 140px);
  overflow: hidden;
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.apphome .box .top {
  display: flex;
}

.apphome {
  padding: 15px;
  /* overflow-x: scroll; */
  display: flex;
  margin-top: 1rem;
}
</style>
